// Vendor
import { createReducer, on } from '@ngrx/store';
// Enums
import { ReportNamingConvention } from '../../enums/naming-convention.enum';
// Actions
import { setNamingConvention } from './naming-convention.actions';
export const namingConvention = createReducer(ReportNamingConvention.TRUNCATED, on(setNamingConvention, (state, action) => {
    return action.namingConvention;
}));
